<template>
   <div class="ui basic segment">
     <table class="ui celled table">
       <thead>
       <tr>
         <th></th>
         <th>Title</th>
         <th>Regex</th>
       </tr>
       </thead>
       <tbody>
       <tr>
         <td>
           <button class="ui tiny inverted green icon button" @click="() => {createTag();}" title="Erstellen">
             <i class="ui plus icon"></i>
           </button>
         </td>
         <td>
           <div class="ui input">
             <input type="text" ref="title">
           </div>
         </td>
         <td>
           <div class="ui input">
             <input type="text" ref="regex">
           </div>
         </td>
       </tr>
       <tr v-for="tag in tags" :key="tag.id">
         <td>
           <button class="ui tiny inverted red icon button" @click="() => {deleteTag(tag.id);}" title="Löschen">
             <i class="ui remove icon"></i>
           </button>
         </td>
         <td>
           <div class="ui input">
             <input type="text" :value="tag.title" @input="(input) => {setTagTitle(tag.id, input.target.value);}">
           </div>
         </td>
         <td>
           <div class="ui input">
             <input type="text" :value="tag.regex" @input="(input) => {setTagRegex(tag.id, input.target.value);}">
           </div>
         </td>
       </tr>
       </tbody>
     </table>
   </div>
</template>

<script>
    export default {
        name: 'Tags',
        data: function () {
          return {
            data: {} // {notes: "", date: [workLogs: {topic, from, to, isBreak}, startTime: timestamp], tags: []}
          }
        },
        computed: {
          tags: function () {
            let tags = [];
            for (const tagId in this.data.tags) {
              if (this.data.tags.hasOwnProperty(tagId) && this.data.tags[tagId] !== undefined) {
                tags.push({
                  id: tagId,
                  title: this.data.tags[tagId].title,
                  regex: this.data.tags[tagId].regex
                });
              }
            }
            return tags.reverse();
          }
        },
        watch: {
          data: {
            handler() {
              localStorage.setItem('data', JSON.stringify(this.data));
            },
            deep: true,
          }
        },
        created: function () {
          try {
            this.data = JSON.parse(localStorage.getItem('data'));
          } catch (e) {
            console.warn("Could not Parse LocalStorage", e);
          }

          if (this.data == null) {
            this.data = {
              tags: {},
              tagTitleToId: {}
            };
          }
        },
        methods: {
            generateRandomHex: function () {
              return 'xxxxxxxx'.replace(/x/g, () => {
                return (Math.random() * 16 | 0).toString(16);
              });
            },
            generateUniqueRandomHex: function () {
              let randomHex = this.generateRandomHex();
              while (this.data.tags.hasOwnProperty(randomHex)) {
                randomHex = this.generateRandomHex();
              }
              return randomHex;
            },
            setTagTitle: function(tagId, title) {
              this.$set(this.data.tagTitleToId, this.data.tags[tagId].title, undefined);
              this.$set(this.data.tags[tagId], 'title', title);
              this.$set(this.data.tagTitleToId, title, tagId);
            },
            setTagRegex: function(tagId, regex) {
              this.$set(this.data.tags[tagId], 'regex', regex);
            },
            deleteTag: function(tagId) {
              const tag = this.data.tags[tagId];
              if (confirm('Wollen Sie wirklich den Tag mit dem Titel "' + tag.title + '" löschen?\nDer Tag wird auch aus allen Einträgen die diesen enthalten entfernt.')) {
                if (this.data.tags.hasOwnProperty(tagId) && this.data.tags[tagId] !== undefined) {
                  this.$set(this.data.tagTitleToId, this.data.tags[tagId].title, undefined);
                  this.$set(this.data.tags, tagId, undefined);
                }
              }
            },
            createTag: function() {
              let title = this.$refs.title.value;
              let regex = this.$refs.regex.value === '' ? null : this.$refs.regex.value;
              if (title !== '') {
                const newTagId = this.generateUniqueRandomHex();
                this.$set(this.data.tags, newTagId, {
                  title: title,
                  regex: regex,
                  neverUsed: true
                });
                this.$set(this.data.tagTitleToId, title, newTagId);
              }
              this.$refs.title.value = '';
              this.$refs.regex.value = '';
            }
        }
    }
</script>

<style scoped>
</style>
